import { css, keyframes } from '@sitebase/emotion';

export var animationSlideInBottom = /*#__PURE__*/keyframes('from{transform:translateY(-100%);}to{transform:translateY(0);}');

export var animationSlideOutBottom = /*#__PURE__*/keyframes('from{transform:translateY(0);}to{transform:translateY(-100%);}');

export var animationSlideInTop = /*#__PURE__*/keyframes('from{transform:translateY(100%);}to{transform:translateY(0);}');

export var animationSlideOutTop = /*#__PURE__*/keyframes('from{transform:translateY(0);}to{transform:translateY(100%);}');

export var root = /*#__PURE__*/css('display:flex;flex-direction:column;flex-grow:1;overflow:hidden;position:absolute;');

export var rootFixed = /*#__PURE__*/css('position:fixed;');

export var slider = /*#__PURE__*/css('animation:0.3s 1 ease-out;animation-fill-mode:forwards;display:flex;flex-grow:1;overflow:hidden;width:100%;will-change:transform;');

export var content = /*#__PURE__*/css('display:flex;flex-grow:1;overflow:hidden;');